import { type ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

export type BadgeProps = {
  size?: 'sm' | 'md' | 'lg';
  color?:
    | 'yellow'
    | 'red'
    | 'green'
    | 'greenDarker'
    | 'gray'
    | 'neutral'
    | 'accent'
    | 'orange'
    | 'lavander'
    | 'redDarker'
    | 'accent-contrast'
    | 'gradient'
    | 'red-contrast';
  children: ReactNode;
  className?: string;
};

export function Badge(props: BadgeProps) {
  const sizeClassNames = {
    sm: 'py-0.5 px-2 font-body-3-m h-[21px]',
    md: 'py-0.5 px-2.5 font-body-2-m h-[24px]',
    lg: 'py-1 px-3 font-body-2-m h-[28px]',
  }[props.size ?? 'md'];
  const colorClassNames = {
    yellow: 'bg-yellow-100 text-yellow-600',
    red: 'bg-red-50 text-red-500',
    redDarker: 'bg-red-100 text-red-600',
    green: 'bg-green-50 text-green-500',
    greenDarker: 'bg-green-100 text-green-600',
    gray: 'text-branding-gray-600 bg-branding-gray-50',
    neutral: 'bg-lavander-50 text-lavander-700',
    accent: 'bg-branding-accent-50 text-branding-accent-600',
    orange: 'bg-orange-100 text-orange-400',
    lavander: 'bg-lavander-200 text-lavander-800',
    'accent-contrast': 'bg-branding-accent text-white',
    gradient: 'bg-gradient-to-r from-branding-accent-600 to-purple-700 text-white',
    'red-contrast': 'bg-red-600 text-white',
  }[props.color ?? 'neutral'];
  return (
    <div
      className={twMerge(
        `${sizeClassNames} ${colorClassNames} flex items-center justify-center gap-1 whitespace-nowrap rounded-2xl`,
        props.className
      )}
    >
      {props.children}
    </div>
  );
}
